import RiCheckFill from '@ben/icons/check-fill';
import RiExpandUpDownLine from '@ben/icons/expand-up-down-line';
import type { ComboboxOptionProps, ComboboxProps } from '@mantine/core';
import { Combobox as MantineCombobox } from '@mantine/core';
import { memo } from 'react';
import RIcon from '../remix-icon';
import { GlobalComboboxStyles } from './combobox.styles';

const Combobox = (props: ComboboxProps) => (
  <>
    <GlobalComboboxStyles />
    <MantineCombobox {...props} />
  </>
);

const Option = ({ active, children, ...rest }: ComboboxOptionProps) => {
  return (
    <MantineCombobox.Option active={active} {...rest}>
      {children}
      {active && <RIcon icon={RiCheckFill} />}
    </MantineCombobox.Option>
  );
};

const Chevron = ({ color }: { color?: string }) => {
  return <RIcon icon={RiExpandUpDownLine} size="sm" color={color} />;
};

export default Object.assign(memo(Combobox), {
  Target: MantineCombobox.Target,
  Dropdown: MantineCombobox.Dropdown,
  Options: MantineCombobox.Options,
  Option,
  Chevron,
  Empty: MantineCombobox.Empty,
});
